import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-dark-bg text-white pt-16 pb-20 px-4 md:px-8 border-b border-dark-surface" data-id="element-40">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-41">
        <div className="flex-1 text-center lg:text-left" data-id="element-42">
          <h1 className="font-oswald text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 uppercase tracking-tight" data-id="element-43">
            Eliminá la{' '}
            <span className="text-brand-orange" data-id="element-44">"Panza de Estrés"</span> en 14
            días sin pisar un gimnasio ni dejar de comer carne.
          </h1>
          <h2 className="font-inter text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto lg:mx-0" data-id="element-45">
            El Protocolo de Desinflamación Metabólica diseñado para hombres de
            30-50 años que necesitan resultados reales (aunque no tengan tiempo
            para hacer dieta).
          </h2>
          <CTAButton data-id="element-46">👉 ¡SÍ, QUIERO ELIMINAR MI PANZA AHORA!</CTAButton>
          <p className="font-inter text-sm text-gray-500 mt-4" data-id="element-47">
            Pago seguro garantizado. Recibís el PDF al instante en tu email.
          </p>
        </div>
        <div className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-48">
          <div className="absolute inset-0 bg-brand-orange/20 blur-[100px] rounded-full pointer-events-none" data-id="element-49"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gtH1AeayVPdnYugjcA5RXV/Mockuo_Cero_Panza_14.png" alt="Cero Panza 14 Program Mockup" className="w-full h-auto relative z-10 drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-50" />
        </div>
      </div>
    </section>;
}